import React from "react";
import { Menu, Dropdown } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import Craft from "components/craft";
import Icons from 'components/icons';
import { EntityRemoveButton, Localize } from 'components/service';

const GraphicStandWarehouseActionField = ({ craftData, stand }) => {
    const craftID = craftData?.id;

    const {
        _setMutationCraftDelete,
        loadingMutationCraftDelete,
    } = Craft.Hooks.delete({ craftID });

    if (!craftData) {
        return <strong>&mdash;</strong>;
    }

    const menu = (
        <Menu
            items={[
                {
                    key: '4',
                    icon:
                        <EntityRemoveButton
                            modalButton={
                                <span style={{ display: 'flex', alignItems: 'center', width: '100%' }}><Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize></span>
                            }
                            nameEntity={Localize({ children: "ENTITY.Modal_Title_Craft" }).props.children}
                            dataNameEntity={craftData?.title}
                            loading={loadingMutationCraftDelete}
                            deleteMutation={_setMutationCraftDelete}
                            variables={{
                                id: craftID,
                            }}
                        />,
                },
            ]}
        />
    );

    return (
        <Dropdown
            // trigger={['click']}
            placement="bottomRight"
            overlay={menu}
            overlayClassName="drop-more-menu"
            arrow
        >
            <EllipsisOutlined className="btn-more" />
        </Dropdown>
    );
};

export default GraphicStandWarehouseActionField;
